// TODO This should load _after_ the GraphQL client is initialized
//      and query for company-specific theme variables.
export const CompanySpecificTheme = ({ children }) => {
  return children;
};
